export default {
  "hero.eyebrow": "Centre de ressources du tableau USFans",
  "hero.title": "Tableau USFans — ressources, guides et outils actualisés",
  "hero.subtitle": "Retrouvez les ressources du tableau USFans, les guides d'achat, les informations sur les vendeurs, les conseils d'expédition et de contrôle qualité, les guides d'entrepôt, les avis et les informations de sécurité — le tout organisé dans un centre de ressources facile à utiliser.",
  "hero.ctaPrimary": "Tableau USFans",
  "hero.ctaSecondary": "Acheter maintenant",
  "hero.ctaGuide": "Voir le guide",
  "hero.trust": "Ressources actualisées · Guides pratiques · Informations de sécurité · Ressource indépendante",

  "categories.title": "Acheter par catégorie",
  "categories.subtitle": "Accédez directement à votre catégorie préférée sur le site principal.",
  "categories.dropdownLabel": "Parcourir les catégories",
  "categories.dropdownPlaceholder": "Sélectionnez une catégorie…",

  "featured.title": "Le tableau USFans, expliqué",
  "featured.body": "Le tableau USFans rassemble des catégories de produits populaires, des liens actualisés et des informations d'achat utiles dans une seule vue organisée. Que vous cherchiez des baskets, des maillots ou que vous compariez les options d'expédition, le tableau vous aide à passer rapidement de la recherche à la bonne page — avec des liens qui vous mènent directement au site principal.",

  "article.title": "Derniers guides et ressources",
  "article.subtitle": "Des guides originaux et détaillés pour tirer le meilleur parti du tableau USFans.",
  "article.cardTitle": "Guide complet du tableau USFans 2026",
  "article.excerpt": "Découvrez ce qu'est le tableau USFans, comment l'utiliser, quelles catégories explorer et les bases de sécurité et d'expédition à connaître avant d'acheter.",
  "article.readMore": "Lire le guide complet",

  "why.title": "Pourquoi cette ressource existe",
  "why.body": "Trouver des informations fiables et à jour sur le tableau USFans peut prendre du temps. Ce centre de ressources indépendant organise l'essentiel — catégories, guides et conseils de sécurité — afin que vous puissiez prendre des décisions éclairées sans parcourir des pages dispersées.",

  "cta.title": "Vous cherchez les dernières ressources USFans ?",
  "cta.body": "Explorez le site principal pour plus d'informations, des liens actualisés et les promotions en cours.",
  "cta.button": "Visiter le site principal",
};